import {addDays, endOfMonth, isAfter, isSameMonth, startOfMonth} from 'date-fns';

import {IsDisabledDateParams, isDisabledDate} from '../../Calendar/utils/isDisabledDate';

export function getInitialCalendarFocusDate(
  value: Date | null,
  activeMonth: Date,
  restrictions: IsDisabledDateParams
) {
  if (value && isSameMonth(value, activeMonth) && !isDisabledDate(value, restrictions)) {
    return value;
  }

  const lastDayOfActiveMonth = endOfMonth(activeMonth);
  let candidateDate = startOfMonth(activeMonth);

  while (!isAfter(candidateDate, lastDayOfActiveMonth)) {
    if (!isDisabledDate(candidateDate, restrictions)) {
      return candidateDate;
    }

    candidateDate = addDays(candidateDate, 1);
  }

  return startOfMonth(activeMonth);
}
